export default {
  'Berry weight': 'g',
  Brix: '°Bx',
  'Brix - initial': '°Bx',
  'Cuvette Size': 'mm',
  FSO2: 'ppm',
  'Free SO2': 'ppm',
  Temperature: '°C',
};
